<div class="d-flex align-items-center quiz-content" [class.hide-badge]="!isFirstQuizBatch">
  <div class="quiz-question">
    @for (n of [].constructor(currentQuestionIndex); track n; let i = $index) {
      <div class="message-container">
        <span class="text">{{ questions[i].question }}</span>
      </div>
      <div class="answers-container">
        @for (answer of questions[i].answers; track answer) {
          <button class="w-full answer-button history-answer" mat-raised-button color="accent" (click)="checkAnswer(questions[i], answer)" [disabled]="questions[i].disabled || isHistoricalBatch || isSavingAnswer" [ngClass]="getAnswerClass(questions[i], answer)">{{ answer.answer }}</button>
        }
      </div>
      @if (questions[i].correctAnswered !== undefined) {
        <p class="answer-result" [ngClass]="{ correct: questions[i].correctAnswered }">
          <app-quiz-reference [answer]="questions[i].correctAnswered ? questions[i].adaptedAnswer?.correct : questions[i].adaptedAnswer?.incorrect" (openSourceModal)="openSourcePreviewModal($event, questions[i])"></app-quiz-reference>
        </p>
      }
      <!-- Show references list after EACH answered quiz -->
      @if (questions[i].correctAnswered !== undefined) {
        <div>
          <app-references
            [references]="getReferencesForQuestion(i)"
            [conversation]="conversation"
            [message]="messageForReferences"
            (sourceSelected)="openSourcePreviewModal($event, questions[i])"
          ></app-references>
        </div>
      }
    }
  </div>
  @if(!isHistoricalBatch) {
    <div class="quiz-button-container">
      @if (canAskForMoreQuestions()) {
        <button type="button" mat-raised-button color="accent" (click)="loadMoreQuestions()">Get more questions</button>
      }
      @if (showMoreQuestions) {
        <button type="button" mat-raised-button color="accent" (click)="getFeedback()">Get feedback</button>
      }
    </div>
  }
</div>
